import { render, staticRenderFns } from "./TicketForm.vue?vue&type=template&id=4b50f509&"
import script from "./TicketForm.vue?vue&type=script&lang=js&"
export * from "./TicketForm.vue?vue&type=script&lang=js&"
import style0 from "./TicketForm.vue?vue&type=style&index=0&id=4b50f509&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports